import React, {Component} from 'react';

import {Form} from 'antd';
import services from '../../services';
import components from '../../components';
import Multiple from './../multiple';

export default class extends Component {
    constructor(props) {
        super(props);

        this.state = {
            authTypeData:[]
        };
        this.domain = {};

        this.session = JSON.parse(sessionStorage.session);
    }

    onSubmit() {
        const data = Object.assign({}, this.props.data, {
            authTypes: this.state.authTypes
        });
        services.dossier.directory.auth.insert(data).then(d => {
            this.handleCancel();
        });
    }

    handleChange(data) {
        this.setState({
            domain: Object.assign({}, data)
        });
    }
    
    handleCancel() {
        this.props.handleCancel();
    }

    querySearchByAuthType() {
        return services.dossier.basic.dictionary.queryDossierEnum("AuthType")
        .then((data) => {
            return data.map(item => {
                return {
                    value: item.value,
                    key: item.value,
                    label: item.label
                }
            });
        }).then(authTypeData => {
            this.setState({
                authTypeData
            })
        });
    }

    render() {
        return (
            <components.Modal styleName="root-modal-copy" title="选择授权类型" width="500px" visible={this.props.visible}  handleSubmit={this.onSubmit.bind(this)} handleCancel={this.handleCancel.bind(this)}>
                <Form layout="inline"
                onSubmit={this.onSubmit.bind(this)}>
                <div className="root-form-body">
                    <Multiple
                        value={this.state.authTypes}
                        style={{width: 300}} 
                        placeholder = {"请输入授权类型"}
                        name="authTypes"
                        search={true}
                        onChange={(data) => {
                            this.setState({
                                authTypes: data
                            });
                        }} 
                        onSearch={() => {
                            this.querySearchByAuthType();
                        }}
                        onFocus={() => {
                            this.querySearchByAuthType();
                        }}
                        label={"授权类型"}
                        data={this.state.authTypeData} 
                    />
                </div>
                </Form>
            </components.Modal>
        )
    }
}